/**
 * PHI-gated admin routes (GDN-2772) answer 403 with a machine-readable
 * `phi_access_denied` code rather than a bare Forbidden: Admin and
 * `staff:phi_read` get through, a plain Moderator does not. Callers need to
 * tell that apart from a generic failure so the UI can say what's actually
 * wrong instead of "something went wrong".
 *
 * The two-depth body search and the status guard both live in `api-error` —
 * see that module for why each is load-bearing.
 */
import { type ApiErrorMatch, apiErrorMessage, matchesApiError } from './api-error';

const PHI_ACCESS_DENIED: ApiErrorMatch = { status: 403, errorCode: 'phi_access_denied' };

/**
 * True when an RTK Query error is the PHI gate refusing the caller, as opposed
 * to any other 403 or a transport failure.
 */
export const isPhiAccessDenied = (error: unknown): boolean =>
  matchesApiError(error, PHI_ACCESS_DENIED);

/** The gate's own explanation, when it sent one worth showing. */
export const phiAccessDeniedMessage = (error: unknown): string | undefined =>
  apiErrorMessage(error, PHI_ACCESS_DENIED);
